(function () {
  'use strict';

  angular.module('PrintixProviderPrinter', [])

    .constant('SUPPORTED_OS', [
      {
        key: 'WIN_11_ARM64',
        value: 'Windows 11 Arm64'
      },
      {
        key: 'WIN_11_64',
        value: 'Windows 11 x64'
      },
      {
        key: 'WIN_10_64',
        value: 'Windows 10 x64'
      },
      {
        key: 'WIN_10_32',
        value: 'Windows 10 x32'
      },
      {
        key: 'WIN_8_1_64',
        value: 'Windows 8.1 x64'
      },
      {
        key: 'WIN_8_1_32',
        value: 'Windows 8.1 x32'
      },
      {
        key: 'WIN_8_64',
        value: 'Windows 8 x64'
      },
      {
        key: 'WIN_8_32',
        value: 'Windows 8 x32'
      },
      {
        key: 'WIN_7_64',
        value: 'Windows 7 x64'
      },
      {
        key: 'WIN_7_32',
        value: 'Windows 7 x32'
      },
      {
        key: 'WIN_2022_64',
        value: 'Windows 2022 x64'
      },
      {
        key: 'WIN_2019_64',
        value: 'Windows 2019 x64'
      },
      {
        key: 'WIN_2016_64',
        value: 'Windows 2016 x64'
      },
      {
        key: 'WIN_2012R2_64',
        value: 'Windows 2012 R2 x64'
      },
      {
        key: 'WIN_2012_64',
        value: 'Windows 2012 x64'
      },
      {
        key: 'WIN_2008R2_64',
        value: 'Windows 2008 R2 x64'
      },
      {
        key: 'WIN_OS',
        value: 'Windows'
      },
      {
        key: 'MAC_10_13',
        value: 'macOS 10.13'
      },
      {
        key: 'MAC_10_12',
        value: 'macOS 10.12'
      },
      {
        key: 'MAC_10_11',
        value: 'macOS 10.11'
      },
      {
        key: 'MAC_10_10',
        value: 'macOS 10.10'
      },
      {
        key: 'MAC_10_9',
        value: 'macOS 10.9'
      },
      {
        key: 'MAC_10_8',
        value: 'macOS 10.8'
      },
      {
        key: 'MAC_OS',
        value: 'macOS'
      },
      {
        key: 'MAC_10_14',
        value: 'macOS 10.14'
      },
      {
        key: 'MAC_10_15',
        value: 'macOS 10.15'
      },
      {
        key: 'MAC_10_16',
        value: 'macOS 11'
      },
      {
        key: 'MAC_10_17',
        value: 'macOS 12'
      },
      {
        key: 'MAC_10_18',
        value: 'macOS 13'
      },
      {
        key: 'MAC_10_19',
        value: 'macOS 14'
      },
      {
        key: 'MAC_10_20',
        value: 'macOS 15'
      },
      {
        key: 'MAC_26',
        value: 'macOS 26'
      }
    ])

    .constant('PRINTER_CREATION_STATUSES', {
      RETRIEVING_MODEL: 'RETRIEVING_MODEL',
      RETRIEVING_INFO: 'RETRIEVING_INFO',
      FAILED_NO_PROXY: 'FAILED_NO_PROXY',
      FAILED_DEVICE_NOT_FOUND: 'FAILED_DEVICE_NOT_FOUND',
      FAILED_PRINTER_NOT_FOUND: 'FAILED_PRINTER_NOT_FOUND',
      FAILED_UNKNOWN_PARAMETERS: 'FAILED_UNKNOWN_PARAMETERS',
      FAILED_UNKNOWN_REASON: 'FAILED_UNKNOWN_REASON',
      FAILED_TIMEOUT: 'FAILED_TIMEOUT',
      MISSING_MODEL: 'MISSING_MODEL',
      MISSING_DRIVERS: 'MISSING_DRIVERS'
    })

    .constant('PRINTER_STATUSES', {
      READY: 'READY',
      BUSY: 'BUSY',
      REQUIRES_ATTENTION: 'REQUIRES_ATTENTION',
      UNAVAILABLE: 'UNAVAILABLE'
    })

    .constant('PDLS', {
      PDF: 'PDF',
      PCLXL: 'PCLXL',
      PCL5: 'PCL5',
      POSTSCRIPT: 'POSTSCRIPT'
    })

    .constant('PRINTER_STATUS_ERROR', [
      'NO_PAPER',
      'NO_TONER',
      'DOOR_OPEN',
      'JAMMED',
      'OFFLINE',
      'INPUT_TRAY_MISSING',
      'OUTPUT_TRAY_MISSING',
      'MARKER_SUPPLY_MISSING',
      'OUTPUT_FULL',
      'INPUT_TRAY_EMPTY',
      'POLL_FAILED'
    ])

    .constant('PRINTER_STATUS_WARNING', [
      'LOW_PAPER',
      'LOW_TONER',
      'SERVICE_REQUESTED',
      'OUTPUT_NEAR_FULL',
      'OVERDUE_PREVENT_MAINT',
      'POLL_TIMED_OUT'
    ])

    .constant('PRINTER_TYPES', {
      NETWORK: 'NETWORK',
      FREEDOM: 'FREEDOM',
      VIRTUAL: 'VIRTUAL'
    })

    .constant('PRINTER_ISSUES', {
      FAILED_NO_PROXY: {
        code: 2,
        key: 'FAILED_NO_PROXY',
        level: 2,
        solution: [
          'StartYourComputerWithClient',
          'InstallClientOnServer'
        ],
        displayPrinterIpAddress: true
      },
      FAILED_DEVICE_NOT_FOUND: {
        code: 1,
        key: 'FAILED_DEVICE_NOT_FOUND',
        level: 1,
        solution: [
          'IsThePrinterPoweredOn',
          'IsThePrinterConnectedToTheNetwork',
          'IsThePrinterAddressCorrect'
        ],
        displayPrinterIpAddress: true
      },
      FAILED_PRINTER_NOT_FOUND: {
        code: 2,
        key: 'FAILED_PRINTER_NOT_FOUND',
        level: 2,
        solution: [
          'IsThePrinterAddressCorrect'
        ],
        displayPrinterIpAddress: true
      },
      FAILED_UNKNOWN_PARAMETERS: {
        code: 2,
        key: 'FAILED_UNKNOWN_PARAMETERS',
        level: 2,
        solution: [
          'IsSnmpv1BeenDisabledOnThePrinter',
          'IsAFirewallBlockingCommunication'
        ],
        displayPrinterIpAddress: true
      },
      FAILED_UNKNOWN_REASON: {
        code: 2,
        key: 'FAILED_UNKNOWN_REASON',
        level: 2,
        displayPrinterIpAddress: true
      },
      FAILED_TIMEOUT: {
        code: 2,
        key: 'FAILED_TIMEOUT',
        level: 2,
        displayPrinterIpAddress: true
      },
      MISSING_MODEL: {
        code: 2,
        key: 'MISSING_MODEL',
        level: 2,
        solution: [
          'IsSnmpv1BeenDisabledOnThePrinter',
          'IsAFirewallBlockingCommunication'
        ],
        displayPrinterIpAddress: true
      },
      MISSING_DRIVERS: {
        code: 3,
        key: 'MISSING_DRIVERS',
        level: 2,
        solution: [
          'ClickNextToSelectPrinterDrivers'
        ],
        link: '/printerProperties/:printerURL'
      },
      RETRIEVING_MODEL: {
        code: 1,
        key: 'RETRIEVING_MODEL',
        level: 1,
        solution: [
          'IsThePrinterPoweredOn',
          'IsThePrinterConnectedToTheNetwork',
          'IsThePrinterAddressCorrect'
        ],
        displayPrinterIpAddress: true
      }
    })

    .constant('RequiredPrinterModelProperties', [
      '_embedded',
      'signId',
      'location'
      // "_embedded.status.printerReportedState"
    ])

    .constant('RequiredPrintQueueModelProperties', [
      '_embedded',
      'active'
      // "_embedded.status.printerReportedState"
    ])

    .constant('PrintQueueEmbeddedPropertiesAdmin', '')

    .constant('PrintQueueEmbeddedProperties', '')

    // .constant("PrinterEmbeddedPropertiesAdmin", "?apiVersion=1&embed=status,groups,lockedDrivers,defaultDrivers,driverConfigurations,snmpConfiguration")
    .constant('PrinterEmbeddedPropertiesAdmin', '?apiVersion=1&embed=status,groups,lockedDrivers,defaultDrivers,driverConfigurations,snmpConfiguration,latestOnDeviceVersion,debugMode')

    .constant('PrinterEmbeddedPropertiesAdminPAGED', '?apiVersion=1&embed=status,groups,networks')

    .constant('PrinterEmbeddedProperties', '?apiVersion=1&embed=status,groups&apply-group-filter=true')

    .factory('PrintQueue', function ($rootScope, Utils, $filter, $http, $q, $injector, RequiredPrintQueueModelProperties, PrintQueueEmbeddedPropertiesAdmin,
      PrintQueueEmbeddedProperties, PrintixPrintQueueInfoConstants, TenantListService, GroupModel, WorkstationListService, WorkstationListPOSTPaging) {
      return function (printQueueDataReceived) {
        // START VARIABLES**************************************************************************************/
        const PrintQueueModel = {
          encodedLink: encodePrintQueueLink(printQueueDataReceived),
          encodedPrinterLink: encodedPrinterLink(printQueueDataReceived),
          printerId: setId(printQueueDataReceived._links['px:printer'].href)
        };
        const PrintQueueModelPrivate = {};
        let GroupListService = null;
        let printQueueUrlSuffix = '';

        function encodePrintQueueLink(printerQueue) {
          return encodeURIComponent(encodeURIComponent(printerQueue._links.self.href));
        }

        function encodedPrinterLink(printerQueue) {
          return encodeURIComponent(encodeURIComponent(printerQueue._links['px:printer'].href));
        }

        try {
          GroupListService = $injector.get('GroupListService');
        } catch (e) { }

        try {
          $injector.get('APIAdmin');
          printQueueUrlSuffix = PrintQueueEmbeddedPropertiesAdmin;
        } catch (e) {
          printQueueUrlSuffix = PrintQueueEmbeddedProperties;
        }
        // END VARIABLES****************************************************************************************/

        // START init*******************************************************************************************/
        PrintQueueModel.init = function (printQueueDataReceived) {
          if (Utils.objectPropertiesCheck(printQueueDataReceived, RequiredPrintQueueModelProperties)) {
            PrintQueueModel.info = angular.copy(printQueueDataReceived);
            PrintQueueModel.options = {
              isSelected: false
            };
            PrintQueueModel.customProperties = {};
            PrintQueueModelPrivate.normalizeLinks();
          } else {
            throw 'PrintQueueModel: printQueueDataReceived is not valid';
          }
        };
        // END init*********************************************************************************************/

        // START PrintQueueModel***********************************************************************************/
        PrintQueueModelPrivate.normalizeLinks = function () {
          if (!PrintQueueModel.info._links['px:group']) {
            PrintQueueModel.info._links['px:group'] = [];
          }
          if (!Array.isArray(PrintQueueModel.info._links['px:group'])) {
            PrintQueueModel.info._links['px:group'] = [PrintQueueModel.info._links['px:group']];
          }

          if (!PrintQueueModel.info._links['px:autoInstallGroup']) {
            PrintQueueModel.info._links['px:autoInstallGroup'] = [];
          }
          if (!Array.isArray(PrintQueueModel.info._links['px:autoInstallGroup'])) {
            PrintQueueModel.info._links['px:autoInstallGroup'] = [PrintQueueModel.info._links['px:autoInstallGroup']];
          }

          angular.forEach(PrintQueueModel.info._links, function (link, index) {
            if (angular.isObject(link) && !angular.isArray(link)) {
              const linkClean = link.href.split('?')[0];
              PrintQueueModel.info._links[index].href = linkClean;
            }
          });

          PrintQueueModel.customProperties.id = setId(PrintQueueModel.info._links.self.href);
        };

        function setId(printerLink) {
          const id = printerLink.split('/');
          return id[id.length - 1];
        }

        PrintQueueModel.replaceInfo = function (embeddedKey, data, replaceOldEmbeddedAndLinks) {
          if (!PrintQueueModel.info._embedded) {
            PrintQueueModel.info._embedded = {};
          }
          if (embeddedKey) {
            PrintQueueModel.info._embedded[embeddedKey] = angular.copy(data);
          } else {
            const embedded = angular.copy(PrintQueueModel.info._embedded);
            const links = angular.copy(PrintQueueModel.info._links);
            PrintQueueModel.info = angular.copy(data);
            if (!replaceOldEmbeddedAndLinks) {
              PrintQueueModel.info._embedded = embedded;
              PrintQueueModel.info._links = links;
            }
            PrintQueueModelPrivate.normalizeLinks();
          }
        };

        PrintQueueModel.refreshInfo = function () {
          const deferred = $q.defer();
          $http.get(PrintQueueModel.info._links.self.href + printQueueUrlSuffix).then(function (response) {
            PrintQueueModel.replaceInfo(null, response.data, true);
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrintQueueModel.showInfo = function () {
          $rootScope.$emit(PrintixPrintQueueInfoConstants.SHOW, PrintQueueModel);
        };

        PrintQueueModelPrivate.readPrintQueueGroupListRequest = function (groupList) {
          if (groupList) {
            PrintQueueModel.info._links['px:group'] = [];
            angular.forEach(groupList.groups, function (group) {
              PrintQueueModel.info._links['px:group'].add(group._links.self);

            });
          } else {
            throw 'PrinterModelPrivate.readPrintQueueListRequest: printQueue is missing';
          }
        };

        PrintQueueModel.getPrintQueueGroupList = function () {
          if (PrintQueueModel.info._links['px:groups'] && PrintQueueModel.info._links['px:groups'].href) {
            const deferred = $q.defer();
            $http.get(PrintQueueModel.info._links['px:groups'].href).then(function (response) {
              const list = [];
              angular.forEach(response.data.groups, function (group) {
                list.add(new GroupModel(group));
              });
              PrintQueueModelPrivate.readPrintQueueGroupListRequest(response.data);
              deferred.resolve(list);
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw "PrintQueueModel.getPrintQueueGroupList: PrintQueueModel.info._links['px:groups'] or PrinterModel.info._links['px:groups'].href are missing";
          }
        };

        PrintQueueModel.getGroupNames = function (parentClasses) {
          if (GroupListService) {
            const arrayOfMessages = [];
            let valueToReturn = '';
            if (PrintQueueModel.info._links['px:group'] &&
                PrintQueueModel.info._links['px:group'].length > 0) {
              angular.forEach(PrintQueueModel.info._links['px:group'], function (groupLink) {
                if (groupLink) {
                  const group = GroupListService.list.findElement({ info: { _links: { self: { href: groupLink.href } } } });
                  if (group) {
                    arrayOfMessages.add($filter('translate')(group.info.name));
                  }
                }
              });
            }
            if (arrayOfMessages.length < 2) {
              valueToReturn = arrayOfMessages[0];
            } else {
              valueToReturn += "<ul class='" + parentClasses + "'>";
              angular.forEach(arrayOfMessages, function (message) {
                valueToReturn += '<li>' + message + '</li>';
              });
              valueToReturn += '</ul>';
            }
            if (!valueToReturn) {
              valueToReturn = '<i class="icon-attention"></i> ' + $filter('translate')('SelectGroupsNone');
            }
            return valueToReturn;
          } else {
            throw 'PrintQueueModel.getGroupNames: GroupListService is missing';
          }
        };

        PrintQueueModel.addGroup = function (group) {
          if (group) {
            const dataToSend = {
              groups: [group.info._links.self.href]
            };
            const deferred = $q.defer();
            $http.post(PrintQueueModel.info._links['px:groups'].href, dataToSend).then(function (response) {
              PrintQueueModel.info._links['px:group'].add({
                href: group.info._links.self.href
              });
              deferred.resolve(response);
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw 'PrintQueueModel.deleteGroup: group is missing';
          }
        };

        PrintQueueModel.addGroupsBulk = function (groups) {
          if (groups) {
            const groupLinks = [];
            for (let i = 0; i < groups.length; i++) {
              groupLinks.push(groups[i].info._links.self.href);
            }
            const dataToSend = {
              groups: groupLinks
            };
            const deferred = $q.defer();
            $http.post(PrintQueueModel.info._links['px:groups'].href, dataToSend).then(function (response) {
              for (let i = 0; i < groups.length; i++) {
                PrintQueueModel.info._links['px:group'].add({ href: groups[i].info._links.self.href });
              }
              deferred.resolve(response);
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw 'PrintQueueModel.deleteGroup: group is missing';
          }
        };

        PrintQueueModel.updateGroups = function (groups) {
          if (groups) {
            const deferred = $q.defer();
            const dataToSend = [];
            for (let i = 0; i < groups.length; i++) {
              const group = {
                groupId: groups[i].info._links.self.href,
                exclusiveAccess: groups[i].info.exclusiveAccess,
                autoInstall: groups[i].info.autoInstall
              };
              dataToSend.push(group);
            }
            const url = PrintQueueModel.info._links['px:groupUpdateRequests'].href;
            $http.post(url, dataToSend).then(function (response) {
              deferred.resolve(response);
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }
        };

        PrintQueueModel.addGroupsToQueue = function (groups) {
          if (groups) {
            const deferred = $q.defer();
            const url = PrintQueueModel.info._links['px:groupUpdateRequests'].href;
            $http.post(url, groups).then(function (response) {
              deferred.resolve(response);
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }
        };

        PrintQueueModel.addExternalGroupsBulk = function (groups) {
          if (groups) {
            const deferred = $q.defer();
            const dataToSend = [];
            for (let i = 0; i < groups.length; i++) {
              const group = {
                provider: groups[i].info.provider,
                externalId: groups[i].info.externalId,
                initialSync: groups[i].info.registeredForSync
              };
              dataToSend.push(group);
            }
            const url = groups[0].info._links['px:createGroup'].href;
            $http.post(url, dataToSend).then(function (response) {
              deferred.resolve(response);
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw 'PrintQueueModel.addExternalGroupsBulk is missing a group';
          }
        };

        PrintQueueModel.deleteGroup = function (group) {
          if (group) {
            const dataToSend = {
              groups: [group.info._links.self.href]
            };
            const deferred = $q.defer();
            $http.delete(PrintQueueModel.info._links['px:groups'].href, {
              headers: {
                'Content-Type': 'application/json'
              },
              data: dataToSend
            }).then(function () {
              PrintQueueModel.info._links['px:group'].removeWith({
                href: group.info._links.self.href
              });
              deferred.resolve();
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw 'PrintQueueModel.deleteGroup: group is missing';
          }
        };

        PrintQueueModel.addAutoInstallGroup = function (groups) {
          if (groups) {
            const groupLinks = [];
            for (let i = 0; i < groups.length; i++) {
              groupLinks.push(groups[i].info._links.self.href);
            }
            const dataToSend = {
              groups: groupLinks
            };
            const deferred = $q.defer();
            $http.post(PrintQueueModel.info._links['px:autoInstallGroups'].href, dataToSend).then(function (response) {
              for (let j = 0; j < groups.length; j++) {
                PrintQueueModel.info._links['px:autoInstallGroup'].add({ href: groups[j].info._links.self.href });
              }
              deferred.resolve(response);
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;

          } else {
            throw 'PrintQueueModel.addAutoInstallGroup: group is missing';
          }
        };

        function checkForUnManagedQueues(dataToSend, workstationsList, printerId) {
          angular.forEach(workstationsList, function (workstation) {
            angular.forEach(workstation._embedded.queues, function (queue) {
              if (PrintQueueModel.info._links.self.href === queue._links['px:queue'].href) {
                const newDataObject = {
                  workstationId: workstation._links.self.href,
                  workstationPrintQueueId: queue._links.self.href,
                  printerId,
                  queueId: PrintQueueModel.info._links.self.href
                };
                dataToSend.push(newDataObject);
              }
            });
          });
          return dataToSend;
        }

        PrintQueueModel.deleteSelectedWorkstations = function (workstationsList, printerId) {
          if (workstationsList, printerId) {
            const deferred = $q.defer();
            let dataToSend = [];
            dataToSend = checkForUnManagedQueues(dataToSend, workstationsList, printerId);
            $http.post(TenantListService.currentTenant.info._links['px:commandDeleteWsQueues'].href, dataToSend).then(function () {
              deferred.resolve();
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw 'Missing workstationList and printerID';
          }
        };

        PrintQueueModel.deleteAutoInstallGroup = function (group) {
          if (group) {
            const dataToSend = {
              groups: [group.info._links.self.href]
            };
            const deferred = $q.defer();
            $http.delete(PrintQueueModel.info._links['px:autoInstallGroups'].href, {
              headers: {
                'Content-Type': 'application/json'
              },
              data: dataToSend
            }).then(function () {
              PrintQueueModel.info._links['px:autoInstallGroup'].removeWith({
                href: group.info._links.self.href
              });
              deferred.resolve();
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw 'PrintQueueModel.deleteAutoInstallGroup: group is missing';
          }
        };

        PrintQueueModel.addQueueToComputers = function (workstations) {
          const dataToSend = [];
          angular.forEach(workstations, function (workstation) {
            dataToSend.push({
              workstationId: workstation.info._links.self.href,
              printerId: PrintQueueModel.info._links['px:printer'].href,
              queueId: PrintQueueModel.info._links.self.href
            });
          });
          const deferred = $q.defer();
          $http.post(TenantListService.currentTenant.info._links['px:commandAddWsQueues'].href, dataToSend).then(function () {
            deferred.resolve();
          }).catch(function (error) {
            deferred.reject(error);
          });
        };

        PrintQueueModel.distributePrintQueueConfigToPrintQueues = function (queues) {
          const toQueues = [];
          angular.forEach(queues, function (queue) {
            toQueues.push(queue.info._links.self.href);
          });

          const dataToSend = {
            toQueues,
            fromQueue: PrintQueueModel.info._links.self.href
          };

          const deferred = $q.defer();
          $http.post(TenantListService.currentTenant.info._links['px:commandCopyQueueConfig'].href, dataToSend).then(function (response) {
            deferred.resolve();
          }).catch(function (error) {
            deferred.reject(error);
          });
        };

        PrintQueueModel.driversAndConfigsChanged = function (driverAndConfigLink) {
          if (driverAndConfigLink) {
            $http.get(driverAndConfigLink).then(function (response) {
              const driverConfigFound = PrintQueueModel.info._embedded.driversAndConfigs.findElement({ os: response.data.os });
              if (driverConfigFound) {
                const index = PrintQueueModel.info._embedded.driversAndConfigs.indexOf(driverConfigFound);
                PrintQueueModel.info._embedded.driversAndConfigs[index] = response.data;
              } else {
                PrintQueueModel.info._embedded.driversAndConfigs.add(response.data);
              }
            }).catch(function (error) {});
          } else {
            throw 'PrintQueueModel.driversAndConfigsChange: driverAndConfigLink is missing';
          }
        };

        PrintQueueModel.getDriverByUrl = function (url) {
          const deferred = $q.defer();
          if (url) {
            $http.get(url).then(function (response) {
              deferred.resolve(response);
            }).catch(function (error) {
              deferred.reject(error);
            });
          } else {
            deferred.reject('urlError');
            return deferred.promise;
            throw 'No url for: getDriverByUrl(url)';
          }
          return deferred.promise;
        };

        function fixMissingSlashEndOfUrl(url) {
          if (url.charAt(url.length - 1) !== '/') {
            return '/';
          }
        }

        PrintQueueModel.addDriver = function (driver, os, driverOriginal) {
          if (driver && os) {
            let isItPatchable = false;
            if (driverOriginal) {
              if (driver._links.self.href !== driverOriginal._links.self.href) {
                isItPatchable = true;
              }
            } else {
              isItPatchable = true;
            }
            const dataToSend = [{
              op: 'add',
              path: '/driver',
              value: driver._links.self.href
            }];
            const deferred = $q.defer();
            let url = PrintQueueModel.info._links['px:driversAndConfig'].href;
            url = url + fixMissingSlashEndOfUrl(url);
            if (isItPatchable) {
              $http.patch(url + os.key + printQueueUrlSuffix, dataToSend).then(function (response) {
                PrintQueueModel.info._embedded.driversAndConfigs.add(response.data);
                deferred.resolve(response);
              }).catch(function (error) {
                deferred.reject(error);
              });
            } else {
              deferred.resolve();
            }
            return deferred.promise;
          } else {
            throw 'PrintQueueModel.addDriver: driver or os are missing';
          }
        };

        PrintQueueModel.deleteDriver = function (os) {
          if (os) {
            const deferred = $q.defer();
            let url = PrintQueueModel.info._links['px:driversAndConfig'].href;
            url = url + fixMissingSlashEndOfUrl(url);
            $http.delete(url + os.key + printQueueUrlSuffix).then(function (response) {
              PrintQueueModel.info._embedded.driversAndConfigs.removeWith({
                os: os.key
              });
              deferred.resolve(response);
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw 'PrintQueueModel.deleteDriver: os or driverIndex are missing';
          }
        };

        PrintQueueModel.editDriver = function (driverOriginal, driverChanged) {
          if (driverOriginal && driverChanged) {
            const patchObjectArray = Utils.getObjectsDifferencesForPatching(driverOriginal, driverChanged);
            if (patchObjectArray && patchObjectArray.length > 0) {
              const deferred = $q.defer();
              $http.patch(driverOriginal._links.self.href, patchObjectArray).then(function (response) {
                deferred.resolve(response);
              }).catch(function (error) {
                deferred.reject(error);
              });
              return deferred.promise;
            } else {
              return $q.resolve();
            }
          } else {
            throw 'PrintQueueModel.editDriver: driverOriginal or driverChanged are missing';
          }
        };

        PrintQueueModel.deleteDriverConfiguration = function (os) {
          if (os) {
            const dataToSend = [{
              op: 'remove',
              path: '/config'
            }];
            let url = PrintQueueModel.info._links['px:driversAndConfig'].href;
            url = url + fixMissingSlashEndOfUrl(url);
            return $http.patch(url + os.key + printQueueUrlSuffix, dataToSend);
          } else {
            throw 'PrintQueueModel.deleteDriverConfiguration: os is missing';
          }
        };

        PrintQueueModel.manageDriverConfiguration = function (os, driverConfig) {
          if (os && driverConfig) {
            const dataToSend = [{
              op: 'replace',
              path: '/config',
              value: driverConfig._links.self.href
            }];
            const deferred = $q.defer();
            let url = PrintQueueModel.info._links['px:driversAndConfig'].href;
            url = url + fixMissingSlashEndOfUrl(url);
            $http.patch(url + os.key + printQueueUrlSuffix, dataToSend).then(function (response) {
              deferred.resolve(response);
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw 'PrintQueueModel.manageDriver: driverConfig or os are missing';
          }
        };

        PrintQueueModel.checkForDriverConflicts = function (os, driverId) {
          if (os && driverId) {
            const deferred = $q.defer();
            const driverIdCleaned = driverId.split('printerdrivers/')[1];
            let url = PrintQueueModel.info._links['px:driverConflicts'].href;
            url = url + '?os=' + os + '&driverId=' + driverIdCleaned + '&embed=printerQueues';
            $http.get(url).then(function (response) {
              deferred.resolve(response);
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw 'PrintQueueModel.checkForDriverConflicts: is missing either os or driverId';
          }
        };

        PrintQueueModel.hasQueueGroupsEnabled = function (queue) {
          let groupsEnabled = false;
          const exclusiveAccess = queue.info._links['px:group'];
          const autoInstall = queue.info._links['px:autoInstallGroup'];
          if ((exclusiveAccess && exclusiveAccess.length > 0) || (autoInstall && autoInstall.length > 0)) {
            groupsEnabled = true;
          }

          return groupsEnabled;
        };

        PrintQueueModel.addNetworkToReleaseOtherNetworkList = function (networkIds) {
          const url = PrintQueueModel.info._links['px:releaseFromOtherNetworks'].href;
          const deferred = $q.defer();
          $http.post(url, networkIds).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrintQueueModel.getDriverConfigsKeyMap = function () {
          const deferred = $q.defer();
          $http.get(PrintQueueModel.info._links['px:drivers'].href).then(function (response) {
            deferred.resolve(response.data._embedded['px:printerQueueDriverResources']);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrintQueueModel.removeNetworkFromReleaseOtherNetworkList = function (networkIds) {
          const url = PrintQueueModel.info._links['px:releaseFromOtherNetworks'].href;
          const networkUrl = networkIds.map((networkUrl) => {
            const id = networkUrl.split('/');
            return id[id.length - 1];
          });

          const deferred = $q.defer();
          $http.delete(url, {
            headers: {
              'Content-Type': 'application/json'
            },
            data: networkUrl
          }).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrintQueueModel.saveRoutingPreference = function (payload) {
          let patch = [];
          const preferredWorkstations = payload && Array.isArray(payload.workstationIds) && payload.workstationIds.length >= 1;
          const enablePreferences = payload && (payload.mode === 'PREFERRED' || payload.mode === 'EXCLUSIVE') && preferredWorkstations;

          if (preferredWorkstations && enablePreferences) {
            patch = [
              { op: 'replace', path: '/workstationRoutingMode', value: payload.mode },
              { op: 'replace', path: '/preferredWorkstations',  value: payload.workstationIds.slice() }
            ];
          } else if (preferredWorkstations && !enablePreferences) {
            patch = [
              { op: 'remove', path: '/workstationRoutingMode' },
              { op: 'replace', path: '/preferredWorkstations',  value: payload.workstationIds.slice() }
            ];
          } else {
            patch = [
              { op: 'remove', path: '/workstationRoutingMode' },
              { op: 'remove', path: '/preferredWorkstations' }
            ];
          }
          const url = PrintQueueModel.info._links.self.href;
          return $http.patch(url, patch, { headers: { 'Content-Type': 'application/json-patch+json' } });
        };

        PrintQueueModel.getPreferredWorkstationsList = function () {
          const deferred = $q.defer();
          if (PrintQueueModel.info.preferredWorkstations) {
            const paging = new WorkstationListPOSTPaging();
            paging.pagingCriteria.page = 0;
            paging.pagingCriteria.pageSize = 10;
            paging.pagingCriteria.workstations = PrintQueueModel.info.preferredWorkstations;
            paging.pagingCriteria.embedded = ["networks"];
            WorkstationListService.postGetWorkstationListPaged(paging).then(function (response) {
              deferred.resolve(response.list);
            }).catch(function (error) {
              deferred.reject(error);
            });
          } else {
            deferred.resolve([]);
          }
          return deferred.promise;
        };

        // END PrintQueueModel*************************************************************************************/

        // START SaveChanges************************************************************************************/
        PrintQueueModel.saveChanges = function (printQueueChanged) {
          if (printQueueChanged) {
            const patchObjectArray = Utils.getObjectsDifferencesForPatching(PrintQueueModel.info, printQueueChanged.info);
            for (let i = 0; i < patchObjectArray.length; i++) { // handheld hack that prevents ("/queueGroupList") gets patched by mistake
              if (patchObjectArray[i].path.substring(0, 15) === '/queueGroupList') {
                patchObjectArray.splice(i, 1);
                i--;
              }
            }
            if (patchObjectArray && patchObjectArray.length > 0) {
              const deferred = $q.defer();
              $http.patch(PrintQueueModel.info._links.self.href + printQueueUrlSuffix, patchObjectArray).then(function (response) {
                PrintQueueModel.replaceInfo(null, response.data);
                deferred.resolve(response);
              }).catch(function (error) {
                deferred.reject(error);
              });
              return deferred.promise;
            } else {
              return $q.resolve();
            }
          } else {
            throw 'PrintQueueModel.saveChanges: printQueueChanged is missing';
          }
        };
        // END SaveChanges**************************************************************************************/

        // START CREATE*****************************************************************************************/
        PrintQueueModel.init(printQueueDataReceived);
        delete PrintQueueModel.init;
        // END CREATE*******************************************************************************************/

        return PrintQueueModel;
      };
    }
    )

    .factory('PrintQueueListPaging', function ($rootScope, Utils, $filter, $http, $q, $injector, DEFAULT_ITEMS_PER_PAGE) {
      return function () {
        // START VARIABLES**************************************************************************************/
        const PrintQueueListPaging = {};
        const PrintQueueListPagingPrivate = {};
        PrintQueueListPaging.pagingCriteria = {
          page: 0,
          pageSize: DEFAULT_ITEMS_PER_PAGE,
          direction: 'ASC',
          match: null,
          sort: 'QUEUE_NAME',
          embed: null,
          active: null,
          autoInstall: null,
          autoRemove: null,
          autoUpdate: null,
          defaultDuplex: null,
          defaultMono: null,
          printerTypes: null,
          // If viaCloud property exists, it will set global and releaseFromOtherNetworksEnabled properties
          global: null,
          releaseFromOtherNetworksEnabled: null,
          networks: null,
          wsCountFrom: null,
          wsCountTo: null,
          alwaysReprint: null,
          networkTypeFilter: null
        };

        return PrintQueueListPaging;
      };
    }
    )

    .service('PrintQueueListService', function ($rootScope, PrintQueue, $filter, Utils, TenantListService, EventServiceEvents, USER_RIGHTS, $http,
      $q, PrintQueueEmbeddedPropertiesAdmin, PrintQueueEmbeddedProperties, $injector, uuid, PrintQueuePropertiesModel,
      PrintQueuePropertiesService) {

      const PrintQueueListModelPrivate = {};
      const printQueueListServiceAsObject = this;
      let printQueueUrlSuffix = '';
      let printQueueAsObject = {};
      try {
        $injector.get('APIAdmin');
        printQueueUrlSuffix = PrintQueueEmbeddedPropertiesAdmin;
      } catch (e) {
        printQueueUrlSuffix = PrintQueueEmbeddedProperties;
      }

      // START PrintQueueListService*****************************************************************************/
      this.getPrintQueueByURL = function (printQueueURL) {
        if (printQueueURL) {
          const deferred = $q.defer();
          if (printQueueURL) {
            $http.get(printQueueURL + printQueueUrlSuffix).then(function (response) {
              if (response && response.data) {
                printQueueAsObject = new PrintQueue(response.data);
                deferred.resolve(printQueueAsObject);
              } else {
                deferred.reject(response);
              }
            }).catch(function (error) {
              deferred.reject(error);
            });
          }
          return deferred.promise;
        } else {
          throw 'PrintQueueListService.getPrintQueueByURL: printQueueURL is missing';
        }
      };

      this.getPrintQueueById = function (printerId, printQueueId) {
        if (printerId, printQueueId) {
          const url = `${TenantListService.currentTenant.info._links['px:printers'].href}/${printerId}/queues/${printQueueId}${printQueueUrlSuffix}`;
          const deferred = $q.defer();
          $http.get(url).then(function (response) {
            if (response && response.data) {
              printQueueAsObject = new PrintQueue(response.data);
              deferred.resolve(printQueueAsObject);
            } else {
              deferred.reject(response);
            }
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        } else {
          throw 'PrintQueueListService.getPrintQueueById: printQueueId is missing';
        }
      };

      this.deletePrintQueue = function (printQueue) {
        if (printQueue) {
          const deferred = $q.defer();
          $http.delete(printQueue.info._links.self.href).then(function () {
            deferred.resolve();
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        } else {
          throw 'PrintQueueListService.deletePrintQueue: printQueue is missing';
        }
      };

      function createDeleletBatch(printQueues, requestMethod) {
        const batchList = [];
        angular.forEach(printQueues, function (printQueue) {
          const batchItem = {
            id: uuid.v4(),
            url: printQueue.info._links.self.href,
            httpMethod: requestMethod
          };

          batchList.push(batchItem);
        });
        return batchList;
      }

      this.bathcDeletePrintQueues = function (printQueues, requestMethod, reference) {
        const defered = $q.defer();
        const batchURL = TenantListService.currentTenant.info._links['px:batch'].href + '?strict=true';

        const batchObject = {
          batchOperations: createDeleletBatch(printQueues, requestMethod),
          reference
        };

        $http.post(batchURL, batchObject).then(function (response) {
          defered.resolve(response);
        }).catch(function (error) {
          defered.reject(error);
        });
        return defered.promise;
      };

      this.deleteSelectedPrintQueues = function (printQueueList, callback) {
        if (printQueueList && printQueueList.length > 0) {
          angular.forEach(printQueueList, function (printQueue) {
            printQueueListServiceAsObject.deletePrintQueue(printQueue);
          });
          if (callback) {
            callback();
          }
        } else {
          throw 'PrintQueueListService.deleteSelectedPrintQueues: printQueueList is missing or it`s length is less than 1';
        }
      };

      this.getPrintQueueListPaged = function functionName(printQueueListPaging) {
        if (printQueueListPaging.pagingCriteria.networks && !Array.isArray(printQueueListPaging.pagingCriteria.networks)) {
          printQueueListPaging.pagingCriteria.networks = printQueueListPaging.pagingCriteria.networks.split(',');
        }
        if (printQueueListPaging && TenantListService.currentTenant && TenantListService.currentTenant.info) {
          const deferred = $q.defer();
          printQueueListPaging = hackNetworkTypeFilter(printQueueListPaging);
          applyViaCloudFilter(printQueueListPaging);
          $http.post(TenantListService.currentTenant.info._links['px:queues'].href, printQueueListPaging.pagingCriteria).then(function (response) {
            const printQueueListObject = {
              page: response.data.page,
              _links: response.data._links,
              list: []
            };
            if (response.data && response.data._embedded && response.data._embedded['px:printerQueueResources']) {
              angular.forEach(response.data._embedded['px:printerQueueResources'], function (printQueueData) {
                printQueueListObject.list.add(new PrintQueue(printQueueData));
              });
            }
            deferred.resolve(printQueueListObject);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        } else {
          throw 'PrintQueueListService.getPrintQueueListPaged: printQueueListPaging or TenantListService.currentTenant or TenantListService.currentTenant.info are missing';
        }
      };

      // THIS IS A PIECE OF HAGGIS made to force OFFICE as default filter and NONE if both OFFICE & HOME filters is set
      function hackNetworkTypeFilter(printQueueListPaging) {
        if (!printQueueListPaging.pagingCriteria.networkTypeFilter || (printQueueListPaging.pagingCriteria.networkTypeFilter.length === 1 && printQueueListPaging.pagingCriteria.networkTypeFilter[0] === 'OFFICE')) {
          printQueueListPaging.pagingCriteria.networkTypeFilter = ['OFFICE'];
        } else {
          if (printQueueListPaging.pagingCriteria.networkTypeFilter.length === 1 && printQueueListPaging.pagingCriteria.networkTypeFilter[0] === 'HOME') {
            printQueueListPaging.pagingCriteria.networkTypeFilter = ['HOME'];
          } else {
            printQueueListPaging.pagingCriteria.networkTypeFilter = ['NONE'];
          }
        }

        return printQueueListPaging;
      }

      function applyViaCloudFilter(printQueueListPaging) {
        if (printQueueListPaging.pagingCriteria.hasOwnProperty('viaCloud')) {
          switch (printQueueListPaging.pagingCriteria.viaCloud) {
            case null:
              printQueueListPaging.pagingCriteria.global = null;
              printQueueListPaging.pagingCriteria.releaseFromOtherNetworksEnabled = null;
              break;
            case 'No':
              printQueueListPaging.pagingCriteria.global = false;
              printQueueListPaging.pagingCriteria.releaseFromOtherNetworksEnabled = false;
              break;
            case 'AllNetworks':
              printQueueListPaging.pagingCriteria.global = true;
              printQueueListPaging.pagingCriteria.releaseFromOtherNetworksEnabled = null;
              break;
            case 'SelectedNetworks':
              printQueueListPaging.pagingCriteria.global = null;
              printQueueListPaging.pagingCriteria.releaseFromOtherNetworksEnabled = true;
              break;
          }
        }
      }

    }
    )

    /// ///////////////////////////////////////////////////////////////////////////////////////////////////
    /// ///////////////////////////////////////////////////////////////////////////////////////////////////
    /// ///////////////////////////////////////////////////////////////////////////////////////////////////
    /// //////////////////////////                 PRINTER                /////////////////////////////////
    /// ///////////////////////////////////////////////////////////////////////////////////////////////////
    /// ///////////////////////////////////////////////////////////////////////////////////////////////////
    /// ///////////////////////////////////////////////////////////////////////////////////////////////////
    .factory('PrinterModel', function ($rootScope, Utils, PRINTER_CREATION_STATUSES, PRINTER_STATUSES, $filter, PrintixPrinterInfoConstants,
      RequiredPrinterModelProperties, PRINTER_TYPES, $http, $q, $injector, PrinterEmbeddedPropertiesAdmin,
      PrinterEmbeddedProperties, PrintQueue, EventServiceEvents, $window, PrintQueueEmbeddedProperties,
      PrintQueueEmbeddedPropertiesAdmin, TenantListService) {
      return function (printerDataReceived) {
        // START VARIABLES**************************************************************************************/
        let PrinterModel = {
          encodedLink: encodePrinterLink(printerDataReceived)
        };

        function encodePrinterLink(printer) {
          return encodeURIComponent(encodeURIComponent(printer._links.self.href));
        }

        const PrinterModelPrivate = {};
        let printerUrlSuffix = '';
        let printQueueUrlSuffix = '';

        try {
          $injector.get('APIAdmin');
          printerUrlSuffix = PrinterEmbeddedPropertiesAdmin;
          printQueueUrlSuffix = PrintQueueEmbeddedPropertiesAdmin;
        } catch (e) {
          printerUrlSuffix = PrinterEmbeddedProperties;
          printQueueUrlSuffix = PrintQueueEmbeddedProperties;
        }
        // END VARIABLES****************************************************************************************/

        // START init*******************************************************************************************/
        PrinterModel.init = function (printerDataReceived) {
          if (Utils.objectPropertiesCheck(printerDataReceived, RequiredPrinterModelProperties)) {
            PrinterModel.info = angular.copy(printerDataReceived);
            PrinterModel = checkForMissingAttribute(PrinterModel);
            PrinterModel.options = {
              isSelected: false,
              isPinned: false,
              allowToPrint: true,
              isSelectedToPrintOnIt: false,
              allPrintJobsSelected: false
            };
            PrinterModel.resources = {
              queues: []
            };
            PrinterModel.onDeviceVersionData = hashOutOnDeviceVersionData(PrinterModel.info);
            PrinterModelPrivate.readPrintQueueListRequest(PrinterModel.info._embedded.queues);
            PrinterModel.customProperties = {};
            PrinterModelPrivate.normalizeLinks();
            formatCardReaderIds();
          } else {
            throw 'PrinterModel: printerDataReceived is not valid';
          }
        };
        // END init*********************************************************************************************/

        function hashOutOnDeviceVersionData(printer) {

          //  printer.captureVersionStr = "1.0.0.0"
          //  printer._embedded.latestCaptureVersionStr = "1.0.0.1";

          return {
            onDeviceVersionMatch: {
              current: printer.onDeviceVersionStr || 'Unknown',
              latest: printer._embedded.latestOnDeviceVersionStr || 'Unknown',
              match: matchVersion(printer.onDeviceVersionStr, printer._embedded.latestOnDeviceVersionStr)
            },
            captureVersionMatch: {
              current: printer.captureVersionStr || 'Unknown',
              latest: printer._embedded.latestCaptureVersionStr || 'Unknown',
              match: matchVersion(printer.captureVersionStr, printer._embedded.latestCaptureVersionStr)
            }
          };

          function matchVersion(current, latest) {

            if (current && latest) {
              const currentArr = current.split('.');
              const latestArr = latest.split('.');
              let match = 'VERSION_MATCH';

              for (let i = 0; i < currentArr.length; i++) {
                if (currentArr[i] !== latestArr[i]) {
                  match = 'VERSION_MISMATCH';
                }
              }

              return match;
            } else {
              if (!current && !latest) {
                return 'Unknown';
              }

              if (!current) {
                return 'Unknown';
              }

              if (!latest) {
                return 'ONLY_LATEST_VERSION_STRING_NOT_FOUND';
              }
            }
          }
        }

        function formatCardReaderIds() {
          if (PrinterModel.info._embedded.cardReaders) {
            angular.forEach(PrinterModel.info._embedded.cardReaders, (cardReader) => {
              if (cardReader.productId) {
                cardReader.PID = hexFormat(cardReader.productId);
              } else {
                cardReader.PID = null;
              }

              if (cardReader.vendorId) {
                cardReader.VID = hexFormat(cardReader.vendorId);
              } else {
                cardReader.VID = null;
              }
            });
          }
        }

        function hexFormat(ID) {
          const hex = ('000000000000000' + ID.toString(16)).substr(-16);
          const formatHex = '0x' + hex.substr(12, 4);
          return formatHex;
        }

        function checkForMissingAttribute(printer) {
          if (printer.info._embedded.status && !printer.info._embedded.status.pollStatus) {
            printer.info._embedded.status.pollStatus = null;
          }
          return printer;
        }

        // START PrinterModel***********************************************************************************/
        PrinterModelPrivate.normalizeLinks = function () {
          angular.forEach(PrinterModel.info._links, function (link, index) {
            if (angular.isObject(link) && !angular.isArray(link)) {
              const linkClean = link.href.split('?')[0];
              PrinterModel.info._links[index].href = linkClean;
            }
          });
          PrinterModel.customProperties.id = setId(PrinterModel.info._links.self.href);
        };

        function setId(printerLink) {
          const id = printerLink.split('/');
          return id[id.length - 1];
        }

        PrinterModel.replaceInfo = function (embeddedKey, data, replaceOldEmbeddedAndLinks) {
          if (!PrinterModel.info._embedded) {
            PrinterModel.info._embedded = {};
          }
          if (embeddedKey) {
            PrinterModel.info._embedded[embeddedKey] = angular.copy(data);
          } else {
            const embedded = angular.copy(PrinterModel.info._embedded);
            const links = angular.copy(PrinterModel.info._links);
            PrinterModel.info = angular.copy(data);
            if (!replaceOldEmbeddedAndLinks) {
              PrinterModel.info._embedded = embedded;
              PrinterModel.info._links = links;
            }
            PrinterModelPrivate.normalizeLinks();
          }
        };

        PrinterModel.refreshInfo = function () {
          const deferred = $q.defer();
          $http.get(PrinterModel.info._links.self.href + printerUrlSuffix).then(function (response) {
            PrinterModel.replaceInfo(null, response.data, true);
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.showInfo = function () {
          if (!PrinterModel.info.creationState) {
            PrinterModel.refreshStatus().then(function () {
              $rootScope.$emit(PrintixPrinterInfoConstants.SHOW, PrinterModel);
            }).catch(function () {
              $rootScope.$emit(PrintixPrinterInfoConstants.SHOW, PrinterModel);
            });
          } else {
            $rootScope.$emit(PrintixPrinterInfoConstants.SHOW, PrinterModel);
          }
        };

        PrinterModel.retryCreation = function () {
          const deferred = $q.defer();
          const url = PrinterModel.info._links['px:retryCreation'].href;
          $http.post(url).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.resolve(error);
          });
          return deferred.promise;
        };

        PrinterModel.trySavingPrinterWithIssues = function (network, ipAddress) {
          const dataToSend = [];

          if (!PrinterModel.info._links['px:network']) {
            const networkPatchAdd = {
              op: 'add',
              path: '/networkId',
              value: network.info._links.self.href
            };
            dataToSend.push(networkPatchAdd);
          } else if ((network.info._links.self.href && PrinterModel.info._links['px:network']) && (network.info._links.self.href !== PrinterModel.info._links['px:network'].href)) {
            const networkPatchReplace = {
              op: 'replace',
              path: '/networkId',
              value: network.info._links.self.href
            };
            dataToSend.push(networkPatchReplace);
          }

          if (!PrinterModel.info.ipAddress) {
            const ipAddressPatchAdd = {
              op: 'add',
              path: '/ipAddress',
              value: ipAddress
            };
            dataToSend.push(ipAddressPatchAdd);
          } else if (PrinterModel.info.ipAddress !== ipAddress) {
            const ipAddressPatchReplace = {
              op: 'replace',
              path: '/ipAddress',
              value: ipAddress
            };
            dataToSend.push(ipAddressPatchReplace);
          }

          const deferred = $q.defer();
          if (dataToSend.length > 0) {
            $http.patch(PrinterModel.info._links.self.href, dataToSend).then(function (response) {
              deferred.resolve(response);
            }).catch(function (error) {
              deferred.reject(error);
            });
          } else {
            deferred.reject();
          }

          return deferred.promise;

        };

        PrinterModel.refreshStatus = function () {
          if (PrinterModel.info.type !== PRINTER_TYPES.FREEDOM) {
            const statusMethod = 'STATUS';
            const deferred = $q.defer();
            $http.get(PrinterModel.info._links['px:status'].href + '?pollDeviceFirst=true&method=' + statusMethod).then(function (response) {
              PrinterModel.replaceInfo('status', response.data);
              deferred.resolve(PrinterModel);
            }).catch(function (error) {
              deferred.reject(error.data);
            });
            return deferred.promise;
          } else {
            return $q.resolve();
          }
        };

        PrinterModel.refreshTonerStatus = function () {
          if (PrinterModel.info.type !== PRINTER_TYPES.FREEDOM) {
            const statusMethod = 'USAGE';
            const deferred = $q.defer();
            $http.get(PrinterModel.info._links['px:status'].href + '?pollDeviceFirst=true&method=' + statusMethod).then(function (response) {
              PrinterModel.replaceInfo('status', response.data);
              deferred.resolve(PrinterModel);
            }).catch(function (error) {
              deferred.reject(error.data);
            });
            return deferred.promise;
          } else {
            return $q.resolve();
          }
        };

        PrinterModel.retryRefreshStatus_NO_PARAMS = function () {
          if (PrinterModel.info.type !== PRINTER_TYPES.FREEDOM) {
            const deferred = $q.defer();
            $http.get(PrinterModel.info._links['px:status'].href).then(function (response) {
              PrinterModel.replaceInfo('status', response.data);
              deferred.resolve(PrinterModel);
            }).catch(function (error) {
              deferred.reject(error.data);
            });
            return deferred.promise;
          } else {
            return $q.resolve();
          }
        };

        PrinterModel.hasErrors = function () {
          if (PrinterModel.info._embedded.status &&
              PrinterModel.info._embedded.status.errors &&
              PrinterModel.info._embedded.status.errors.length > 0) {

            if (PrinterModel.info._embedded.status.pollStatus) {
              for (let i = 0; i < PrinterModel.info._embedded.status.errors.length; i++) {
                if (PrinterModel.info._embedded.status.errors[i] === 'POLL_FAILED') {
                  PrinterModel.info._embedded.status.errors.splice(i, 1);
                  break;
                }
              }

              if (PrinterModel.info._embedded.status.errors.length > 0) {
                return true;
              }
            } else {
              return true;
            }

          } else {
            return false;
          }
        };

        PrinterModel.hasWarnings = function () {
          if (PrinterModel.info._embedded.status &&
              PrinterModel.info._embedded.status.warnings &&
              PrinterModel.info._embedded.status.warnings.length > 0) {

            if (PrinterModel.info._embedded.status.pollStatus) {
              for (let j = 0; j < PrinterModel.info._embedded.status.warnings.length; j++) {
                if (PrinterModel.info._embedded.status.warnings[j] === 'POLL_TIMED_OUT') {
                  PrinterModel.info._embedded.status.warnings.splice(j, 1);
                  break;
                }
              }
              if (PrinterModel.info._embedded.status.warnings.length > 0) {
                return true;
              }
            } else {
              return true;
            }
          } else {
            return false;
          }
        };

        PrinterModel.hasProxy = function () {
          if (PrinterModel.info._embedded.status._links['px:monitorWs']) {
            return true;
          } else {
            return false;
          }
        };

        PrinterModel.hasOtherIssues = function () {
          let hasOtherIssues = false;
          switch (PrinterModel.info._embedded.status.pollStatus) {
            case 'UNKNOWN_PARAMETERS':
              hasOtherIssues = true;
              break;
            case 'DEVICE_NOT_FOUND':
              hasOtherIssues = true;
              break;
            case 'PRINTER_NOT_FOUND':
              hasOtherIssues = true;
              break;
          }

          return hasOtherIssues;
        };

        PrinterModel.getErrorsAndWarnings = function (parentClasses) {
          // assemble the message array
          const arrayOfMessages = [];
          if (PrinterModel.hasErrors()) {
            angular.forEach(PrinterModel.info._embedded.status.errors, function (error) {
              arrayOfMessages.add($filter('translate')(error));
            });
          }
          if (PrinterModel.hasWarnings()) {
            angular.forEach(PrinterModel.info._embedded.status.warnings, function (warning) {
              arrayOfMessages.add($filter('translate')(warning));
            });
          }
          if (!PrinterModel.hasErrors() && !PrinterModel.hasWarnings()) {
            arrayOfMessages.add($filter('translate')('Ok'));
          }
          // assemble the return markup
          let valueToReturn = '';
          if (arrayOfMessages.length < 2) {
            valueToReturn = arrayOfMessages[0];
          } else {
            valueToReturn += "<ul class='" + parentClasses + "'>";
            angular.forEach(arrayOfMessages, function (message) {
              valueToReturn += '<li>' + message + '</li>';
            });
            valueToReturn += '</ul>';
          }
          return valueToReturn;
        };

        PrinterModel.changePrinterNetwork = function (network) {
          if (network) {
            const deferred = $q.defer();
            const dataToSend = [{
              op: 'replace',
              path: '/networkId',
              value: network.info._links.self.href
            }];
            $http.patch(PrinterModel.info._links.self.href, dataToSend).then(function (response) {
              if (!PrinterModel.info._links['px:network']) {
                PrinterModel.info._links['px:network'] = {};
              }
              PrinterModel.info._links['px:network'].href = network.info._links.self.href;
              deferred.resolve(response);
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw 'PrinterModel.changePrinterNetwork: network is missing';
          }
        };

        PrinterModel.multiSave = function (printerChanged, networkChange) {
          const printerUrl = PrinterModel.info._links.self.href + printerUrlSuffix;
          const patchObjectArray = Utils.getObjectsDifferencesForPatching(PrinterModel.info, printerChanged.info);

          if (networkChange) {
            const networkPatch = {
              op: 'replace',
              path: '/networkId',
              value: networkChange.info._links.self.href
            };
            patchObjectArray.push(networkPatch);
          }

          const deferred = $q.defer();
          $http.patch(printerUrl, patchObjectArray).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            console.log(error);
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.savePortProtocol = function (portProtocol) {
          const deferred = $q.defer();
          const put = {
            protocol: portProtocol.protocol ? portProtocol.protocol : PrinterModel.info._embedded.portProtocol.protocol,
            port: portProtocol.port ? portProtocol.port : PrinterModel.info._embedded.portProtocol.port,
            ippSupportedPath: portProtocol.ippSupportedPath
          };

          if (portProtocol.protocol === 'LPR') {
            put.queueName = portProtocol.queueName ? portProtocol.queueName : PrinterModel.info._embedded.portProtocol.queueName;
          }

          const url = PrinterModel.info._embedded.portProtocol._links.self.href;

          $http.put(url, put).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.resetToDefaultPortProtocol = function () {
          const deferred = $q.defer();
          const url = PrinterModel.info._embedded.portProtocol._links.self.href;
          $http.delete(url).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.printQueueAdded = function (printQueueUrl) {
          if (printQueueUrl) {
            const deferred = $q.defer();
            printQueueUrl = printQueueUrl.split('?')[0];
            const printQueueFound = PrinterModel.resources.queues.findElement({ info: { _links: { self: { href: printQueueUrl } } } });
            if (!printQueueFound) {
              $http.get(printQueueUrl + printQueueUrlSuffix).then(function (response) {
                const queue = new PrintQueue(response.data);
                PrinterModel.resources.queues.add(queue);
                deferred.resolve();
              }).catch(function (error) {
                deferred.reject(error);
              });
            } else {
              deferred.resolve();
            }
            return deferred.promise;
          } else {
            throw 'PrinterModel.printQueueAdded: printQueueUrl is missing';
          }
        };

        PrinterModel.getPrintQueueByURL = function (printQueueURL) {
          if (printQueueURL) {
            return PrinterModel.resources.queues.findElement({
              info: {
                _links: {
                  self: {
                    href: printQueueURL
                  }
                }
              }
            });
          } else {
            throw 'PrinterListModel.getPrintQueueByURL: printQueueURL is missing';
          }
        };

        PrinterModel.createPrintQueue = function (printQueue) {
          if (printQueue) {
            const deferred = $q.defer();
            $http.post(PrinterModel.info._links['px:queues'].href, printQueue).then(function (response) {
              PrinterModel.resources.queues.add(new PrintQueue(response.data));
              deferred.resolve();
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw 'PrinterModel.addPrintQueue: printer is missing';
          }
        };

        PrinterModel.deletePrintQueue = function (printQueue, isEvent) {
          if (printQueue) {
            if (isEvent) {
              PrinterModel.resources.queues.remove(printQueue);
            } else {
              const deferred = $q.defer();
              $http.delete(printQueue.info._links.self.href).then(function () {
                PrinterModel.resources.queues.remove(printQueue);
                deferred.resolve();
              }).catch(function (error) {
                deferred.reject(error);
              });
              return deferred.promise;
            }
          } else {
            throw 'PrinterModel.deletePrintQueue: printer is missing';
          }
        };

        PrinterModel.deleteSelectedPrintQueues = function (searchCriteriaObject, callback) {
          if (searchCriteriaObject) {
            if (PrinterModel.resources.queues.length > 0) {
              const printQueueList = PrinterModel.resources.queues.findAllElements(searchCriteriaObject);
              if (printQueueList.length > 0) {
                angular.forEach(printQueueList, function (printQueue) {
                  PrinterModel.deletePrintQueue(printQueue);
                });
                if (callback) {
                  callback();
                }
              } else {
                throw 'PrinterListService.deleteSelectedPrintQueues: no printQueue was found using the provided search criteria';
              }
            } else {
              throw 'PrinterListService.deleteSelectedPrintQueues: there are not printQueues in printer list';
            }
          } else {
            throw 'PrinterListService.deleteSelectedPrintQueues: searchCriteriaObject is missing';
          }
        };

        PrinterModelPrivate.readPrintQueueListRequest = function (printQueue) {
          if (printQueue) {
            PrinterModel.resources.queues = [];
            angular.forEach(printQueue, function (printQueue) {
              const queue = new PrintQueue(printQueue);
              queue.info.groupsEnabled = queue.hasQueueGroupsEnabled(queue);
              PrinterModel.resources.queues.add(queue);
            });
          } else {
            throw 'PrinterModelPrivate.readPrintQueueListRequest: printQueue is missing';
          }
        };

        PrinterModel.getPrintQueueList = function () {
          if (PrinterModel.info._links['px:queues'] && PrinterModel.info._links['px:queues'].href) {
            const deferred = $q.defer();
            $http.get(PrinterModel.info._links['px:queues'].href + printQueueUrlSuffix).then(function (response) {
              PrinterModelPrivate.readPrintQueueListRequest(response.data._embedded.queues);
              deferred.resolve(response);
            }).catch(function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          } else {
            throw "PrinterModel.getPrintQueueList: rinterModel.info._links['px:queues'] or PrinterModel.info._links['px:queues'].href are missing";
          }
        };

        function combineCsvReportName(prinerInfo) {
          const signInd = prinerInfo.signId ? `${prinerInfo.signId}_` : '';
          const printerName = prinerInfo.name ? prinerInfo.name.replace(' ', '_') : 'printer';
          const postfix = '.report.csv';
          return `${signInd}${printerName}${postfix}`;
        }

        PrinterModel.downloadRawData = function () {
          const deferred = $q.defer();
          const url = PrinterModel.info._links['px:rawdata'].href;
          const config = {
            headers: { Accept: 'text/csv' }
          };
          $http.get(url, config).then(function (response) {
            console.log('response', response);
            const blob = new Blob([response.data], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = combineCsvReportName(PrinterModel.info);
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.removeSnmpConfiguration = function (url) {
          const deferred = $q.defer();
          $http.delete(url).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.assignPrinterCredential = function (printerCredential) {
          const deferred = $q.defer();
          const postObject = {};
          const url = PrinterModel.info._links['px:printerCredential'].href;
          $http.post(url, printerCredential).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.assignOnDeviceConfig = function (deviceConfigId) {
          const deferred = $q.defer();
          const url = PrinterModel.info._links['px:onDeviceConfig'].href;
          $http.post(url, deviceConfigId).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.removeOnDeviceConfig = function (deviceConfigId) {
          const deferred = $q.defer();
          const url = PrinterModel.info._links['px:onDeviceConfig'].href;
          $http.delete(url, deviceConfigId).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;

        };

        PrinterModel.updateDeviceConfig = function (deviceConfigId) {
          const deferred = $q.defer();
          const url = PrinterModel.info._links['px:deviceUpdate'].href;
          $http.put(url).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.verifySignInProfile = function () {
          const deferred = $q.defer();
          let printerId = PrinterModel.info._links.self.href.split('/');
          printerId = printerId[printerId.length - 1];

          const url = PrinterModel.info._links['px:testPrinterCredential'].href + '?printerIds=' + printerId;
          $http.post(url).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.deviceInstall = function () {
          const deferred = $q.defer();
          const url = PrinterModel.info._links['px:deviceInstall'].href;
          $http.put(url).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.deviceUnInstall = function () {
          const deferred = $q.defer();
          const url = PrinterModel.info._links['px:deviceUninstall'].href;
          $http.put(url).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.beginDebugMode = function (debugSession) {
          const deferred = $q.defer();
          const url = PrinterModel.info._links['px:beginDebugMode'].href;
          $http.post(url, debugSession).then(function (response) {
            deferred.resolve(response.data);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.endDebugMode = function (debugMode) {
          const deferred = $q.defer();
          const url = debugMode._links['px:stopDebugMode'].href;
          $http.post(url, {}).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.getDebugMode = function () {
          const deferred = $q.defer();
          const url = PrinterModel.info._links['px:debugMode'].href;
          $http.get(url).then(function (response) {
            deferred.resolve(response.data);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.getAuditEvents = function (debugMode) {
          const deferred = $q.defer();
          const url = debugMode._links['px:auditEvents'].href;
          const customHeaders = { customHeaders: { 'Accept-Language': 'en' } };
          $http.get(url, customHeaders).then(function (response) {
            deferred.resolve(response.data);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        PrinterModel.downloadDebugModeLog = function (debugMode) {
          const deferred = $q.defer();
          const url = debugMode._links['px:downloadDebugModeLog'].href;
          const filename = `printix_printer_debug_log_${debugMode.ended}.csv`;
          const headers = { Accept: 'text/csv' };

          $http({
            method: 'GET',
            url,
            headers,
            responseType: 'blob'
          }).then(function (response) {
            const blob = new Blob([response.data], { type: 'text/csv' });
            const downloadUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        };

        // END PrinterModel*************************************************************************************/

        // START SaveChanges************************************************************************************/
        PrinterModel.saveChanges = function (printerChanged) {
          if (printerChanged) {
            const patchObjectArray = Utils.getObjectsDifferencesForPatching(PrinterModel.info, printerChanged.info);
            if (patchObjectArray && patchObjectArray.length > 0) {
              const deferred = $q.defer();
              $http.patch(PrinterModel.info._links.self.href + printerUrlSuffix, patchObjectArray).then(function (response) {
                PrinterModel.replaceInfo(null, response.data);
                deferred.resolve(response);
              }).catch(function (error) {
                deferred.reject(error);
              });
              return deferred.promise;
            } else {
              return $q.resolve();
            }
          } else {
            throw 'PrinterModel.saveChanges: printerChanged is missing';
          }
        };
        // END SaveChanges**************************************************************************************/

        // START CREATE*****************************************************************************************/
        PrinterModel.init(printerDataReceived);
        delete PrinterModel.init;
        // END CREATE*******************************************************************************************/

        return PrinterModel;
      };
    }
    )

    .factory('PrinterListPOSTPaging', function (DEFAULT_ITEMS_PER_PAGE) {
      return function () {
        const PrinterListPOSTPaging = {
          pagingCriteria: {
            page: 0,
            pageSize: DEFAULT_ITEMS_PER_PAGE,
            direction: 'ASC',
            sort: 'SIGN_ID',
            match: null,
            embed: ['status', 'networks', 'groups', 'onDeviceConfigs', 'printerCredentials', 'snmpConfiguration', 'latestOnDeviceVersion', 'cardReaders'],
            networks: null,
            queuesFrom: null,
            queuesTo: null,
            createdFrom: null,
            matchVendorModel: null,
            types: null,
            includeSnmpConfigurations: null,
            networkFilterEnabled: null,
            includeUnassignedPrinters: null,
            underCreation: false,
            networkTypeFilter: null,
            printers: null
          }
        };

        PrinterListPOSTPaging.getPagedUrlParameters = function () {
          let urlParameters =
              'page=' + PrinterListPOSTPaging.pagingCriteria.page +
              '&pageSize=' + PrinterListPOSTPaging.pagingCriteria.pageSize +
              '&direction=' + PrinterListPOSTPaging.pagingCriteria.direction +
              '&sort=' + PrinterListPOSTPaging.pagingCriteria.sort;

          if (PrinterListPOSTPaging.pagingCriteria.match) {
            urlParameters += '&match=' + PrinterListPOSTPaging.pagingCriteria.match;
          }

          return urlParameters;
        };

        return PrinterListPOSTPaging;
      };
    }
    )

    .service('PrinterListService', function ($rootScope, PrinterModel, $filter, Utils, TenantListService, $injector, PRINTER_TYPES, EventServiceEvents,
      USER_RIGHTS, $http, $q, PrinterEmbeddedPropertiesAdmin, PrinterEmbeddedProperties, PrinterEmbeddedPropertiesAdminPAGED, uuid,
      PrinterListPOSTPaging) {
      // START VARIABLES******************************************************************************************/
      const PrinterListModelPrivate = {};
      const printerListServiceAsObject = this;
      this.drivers = [];
      this.driverConfigs = [];

      const printerUrlSuffix = PrinterEmbeddedPropertiesAdmin;
      const printerUrlSuffixPAGED = PrinterEmbeddedPropertiesAdminPAGED;

      // END VARIABLES********************************************************************************************/

      this.getPrinterByURL = function (printerURL, additionalEmbedded) {
        if (printerURL) {
          let url = printerURL + printerUrlSuffix;
          if (additionalEmbedded) {
            url = url + additionalEmbedded;
          }
          const deferred = $q.defer();
          $http.get(url).then(function (response) {
            if (response && response.data) {
              const printer = new PrinterModel(response.data);
              deferred.resolve(printer);
            } else {
              deferred.reject(response);
            }
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        } else {
          throw 'PrinterListModel.getPrinterByURL: printerURL is missing';
        }
      };

      this.getPrinterById = function (printerId, additionalEmbedded) {
        let url = TenantListService.currentTenant.info._links['px:printers'].href + '/' + printerId + printerUrlSuffix;
        if (additionalEmbedded) {
          url = url + additionalEmbedded;
        }
        if (printerId) {
          const deferred = $q.defer();
          const watch = $rootScope.$watch(function () {
            return TenantListService.currentTenant;
          }, function () {
            if (TenantListService.currentTenant &&
                TenantListService.currentTenant.info._links['px:printers'].href) {
              $http.get(url).then(function (response) {
                if (response && response.data) {
                  deferred.resolve(new PrinterModel(response.data));
                } else {
                  watch();
                  deferred.reject(response);
                }
              }).catch(function (error) {
                watch();
                deferred.reject(error);
              });
            }
          });
          return deferred.promise;
        } else {
          throw 'PrinterModel.getPrinterById: printerId is missing';
        }
      };

      // this.getPrinterByUrl

      this.createPrinter = function (data) {
        if (data && TenantListService.currentTenant) {
          if (data.type === PRINTER_TYPES.FREEDOM) {
            delete data.ipAddress;
          }
          if (data.type === PRINTER_TYPES.NETWORK) {
            delete data.name;
          }
          data.active = true;
          const deferred = $q.defer();
          const url = TenantListService.currentTenant.info._links['px:printers'].href + '?autoRetry=true';
          $http.post(url, data).then(function (response) {
            deferred.resolve(response);
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        } else {
          throw 'PrinterListService.createPrinter: data or TenantListService.currentTenant are missing';
        }
      };

      this.deletePrinter = function (printer) {
        if (printer) {
          const deferred = $q.defer();
          $http.delete(printer.info._links.self.href).then(function () {
            deferred.resolve();
          }).catch(function (error) {
            deferred.reject(error);
          });
          return deferred.promise;
        } else {
          throw 'PrinterListService.deletePrinter: printer is missing';
        }
      };

      this.deleteSelectedPrinters = function (printerList, callback) {
        if (printerList.length > 0) {
          angular.forEach(printerList, function (printer) {
            printerListServiceAsObject.deletePrinter(printer);
          });
          if (callback) {
            callback();
          }
        } else {
          throw 'PrinterListService.deleteSelectedPrinters: there are not printers in printer list';
        }
      };

      function createPatchBatch(printers, requestMethod, printersOriginal) {
        const batchList = [];
        const payload = Utils.getObjectsDifferencesForPatching(printersOriginal[0].info, printers[0].info);
        angular.forEach(printers, function (printer) {
          const batchItem = {
            id: uuid.v4(),
            url: printer.info._links.self.href,
            httpMethod: requestMethod,
            contentType: 'application/json-patch+json',
            payload
          };

          batchList.push(batchItem);
        });
        return batchList;
      }

      this.batchPatchPrinters = function (printers, requestMethod, reference, printersOriginal) {
        const defered = $q.defer();
        const batchURL = TenantListService.currentTenant.info._links['px:batch'].href + '?strict=true';
        const batchObject = {
          batchOperations: createPatchBatch(printers, requestMethod, printersOriginal),
          reference
        };
        $http.post(batchURL, batchObject).then(function (response) {
          defered.resolve(response);
        }).catch(function (error) {
          defered.reject(error);
        });
        return defered.promise;
      };

      this.getPrinterListPaged = function functionName(printerListPaging) {
        if (printerListPaging && TenantListService.currentTenant && TenantListService.currentTenant.info) {
          return this.postGetPrinterListPaged(printerListPaging);
        } else {
          throw 'PrinterListService.getPrinterListPaged: printerListPaging or TenantListService.currentTenant or TenantListService.currentTenant.info are missing';
        }
      };

      this.postGetPrinterListPaged = function (printerListPOSTPaging) {
        const deferred = $q.defer();

        const queryParams =
            'page=' + printerListPOSTPaging.pagingCriteria.page +
            '&pageSize=' + printerListPOSTPaging.pagingCriteria.pageSize +
            '&sort=' + printerListPOSTPaging.pagingCriteria.sort +
            '&direction=' + printerListPOSTPaging.pagingCriteria.direction +
            '&embed=snmp';

        const endpoint = `${TenantListService.currentTenant.info._links['px:printers'].href}?${queryParams}`;

        if (printerListPOSTPaging.pagingCriteria.types && !Array.isArray(printerListPOSTPaging.pagingCriteria.types)) {
          printerListPOSTPaging.pagingCriteria.types = printerListPOSTPaging.pagingCriteria.types.split(',');
        }

        if (printerListPOSTPaging.pagingCriteria.networks && !Array.isArray(printerListPOSTPaging.pagingCriteria.networks)) {
          printerListPOSTPaging.pagingCriteria.networks = printerListPOSTPaging.pagingCriteria.networks.split(',');
        }
        if (printerListPOSTPaging.pagingCriteria.sites && !Array.isArray(printerListPOSTPaging.pagingCriteria.sites)) {
          printerListPOSTPaging.pagingCriteria.sites = printerListPOSTPaging.pagingCriteria.sites.split(',');
        }
        printerListPOSTPaging = hackNetworkTypeFilter(printerListPOSTPaging);

        $http.post(endpoint, printerListPOSTPaging.pagingCriteria).then(function (response) {
          const printerListObject = {
            page: response.data.page,
            _links: response.data._links,
            networks: [],
            list: [],
            sites: [],
            onDeviceConfigResources: [],
            printerCredentialResources: [],
            snmpConfigurationResources: []
          };

          if (response.data && response.data._embedded && response.data._embedded['px:printerResources']) {
            angular.forEach(response.data._embedded['px:printerResources'], function (printerData) {
              printerListObject.list.add(new PrinterModel(printerData));
            });
            angular.forEach(response.data._embedded['px:networkResources'], function (networkData) {
              printerListObject.networks.add(networkData);
            });
            angular.forEach(response.data._embedded['px:siteResources'], function (siteData) {
              printerListObject.sites.add(siteData);
            });

            if (response.data._embedded['px:onDeviceConfigResources']) {
              printerListObject.onDeviceConfigResources = response.data._embedded['px:onDeviceConfigResources'];
            }
            if (response.data._embedded['px:printerCredentialResources']) {
              printerListObject.printerCredentialResources = response.data._embedded['px:printerCredentialResources'];
            }
            if (response.data._embedded['px:snmpConfigurationResources']) {
              printerListObject.snmpConfigurationResources = response.data._embedded['px:snmpConfigurationResources'];
            }

          }
          deferred.resolve(printerListObject);
        }).catch(function (error) {
          deferred.reject(error);
        });
        return deferred.promise;
      };

      // THIS IS A PIECE OF HAGGIS made to force OFFICE as default filter and NONE if both OFFICE & HOME filters is set
      function hackNetworkTypeFilter(printerListPOSTPaging) {
        if (!printerListPOSTPaging.pagingCriteria.networkTypeFilter || (printerListPOSTPaging.pagingCriteria.networkTypeFilter.length === 1 && printerListPOSTPaging.pagingCriteria.networkTypeFilter[0] === 'OFFICE')) {
          printerListPOSTPaging.pagingCriteria.networkTypeFilter = ['OFFICE'];
        } else {
          if (printerListPOSTPaging.pagingCriteria.networkTypeFilter.length === 1 && printerListPOSTPaging.pagingCriteria.networkTypeFilter[0] === 'HOME') {
            printerListPOSTPaging.pagingCriteria.networkTypeFilter = ['HOME'];
          } else {
            printerListPOSTPaging.pagingCriteria.networkTypeFilter = ['NONE'];
          }
        }

        return printerListPOSTPaging;
      }

      this.checkPrinterPrintQueueDrivers = function (printer) {
        printerListServiceAsObject.driverConfigs = [];
        if (printer) {
          angular.forEach(printer.info._embedded.defaultDrivers, function (defaultDriver) {
            printerListServiceAsObject.verifyDriverAndConfig(defaultDriver._links.self, null);
          });
          angular.forEach(printer.resources.queues, function (queue) {
            angular.forEach(queue.info._embedded.driversAndConfigs, function (driversAndConfig) {
              printerListServiceAsObject.verifyDriverAndConfig(driversAndConfig._links['px:driver'], driversAndConfig._links['px:driverConfig']);
            });
          });
        } else {
          throw 'PrinterListService.checkPrinterPrintQueueDrivers: printer is missing';
        }
      };

      this.verifyDriverAndConfig = function (driverLink, driverConfigLink) {
        const deferred = $q.defer();

        if (driverLink && driverLink.href) {
          if (!printerListServiceAsObject.drivers.findElement({
            _links: {
              self: {
                href: driverLink.href
              }
            }
          })) {
            $http.get(driverLink.href).then(function (response) {
              printerListServiceAsObject.drivers.add(response.data);
              deferred.resolve();
            }).catch(function (error) {
              deferred.reject(error);
            });
          } else {
            deferred.resolve();
          }
        } else {
          deferred.resolve();
        }

        if (driverConfigLink && driverConfigLink.href) {
          if (!printerListServiceAsObject.driverConfigs.findElement({ _links: { self: { href: driverConfigLink.href } } })) {
            $http.get(driverConfigLink.href).then(function (response) {
              printerListServiceAsObject.driverConfigs.add(response.data);
              deferred.resolve();
            }).catch(function (error) {
              deferred.reject(error);
            });
          } else {
            deferred.resolve();
          }
        } else {
          deferred.resolve();
        }

        return deferred.promise;
      };

      this.getPrintersDefaultDrivers = function (defaultDriverUrl) {
        const deferred = $q.defer();

        $http.get(defaultDriverUrl).then(function (response) {
          deferred.resolve(response);
        }).catch(function (error) {
          deferred.reject(error);
        });

        return deferred.promise;
      };

      this.getDriverForPrintQueueOS = function (printer, printQueue, os, returnOnlyLink) {
        if (printer && printQueue && os) {
          try {
            if (printQueue.info._embedded.driversAndConfigs &&
                printQueue.info._embedded.driversAndConfigs.findElement({
                  os
                })) {
              const printQueueDriverLinkForOS = printQueue.info._embedded.driversAndConfigs.findElement({
                os
              })._links['px:driver'].href;
              if (returnOnlyLink) {
                return printQueueDriverLinkForOS;
              } else {
                return printerListServiceAsObject.drivers.findElement({
                  _links: {
                    self: {
                      href: printQueueDriverLinkForOS
                    }
                  }
                });
              }
            } else {
              if (printer.info._embedded.defaultDrivers) {
                const printerDefaultDriverLinkForOS = printer.info._embedded.defaultDrivers.findElement({
                  operatingSystem: os
                })._links.self.href;
                if (returnOnlyLink) {
                  return printerDefaultDriverLinkForOS;
                } else {
                  return printerListServiceAsObject.drivers.findElement({
                    _links: {
                      self: {
                        href: printerDefaultDriverLinkForOS
                      }
                    }
                  });
                }
              } else {
                return null;
              }
            }
          } catch (e) {
            return null;
          }
        } else {
          throw 'PrinterListService.getDriverForPrintQueueOS: printer or printQueue or os are missing';
        }
      };
      // END PrinterListService***********************************************************************************/
    }
    );
})();
